
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[unitId]",
      function () {
        return require("private-next-pages/[unitId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[unitId]"])
      });
    }
  